import * as React from 'react'

import { Box, Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import ClockPicturePreview from 'modules/employees/components/FaceRecognition/Logs/ClockPicturePreview'
import type ClockPicture from 'modules/employees/store/models/ClockPicture'

import DisplayImageAction from './DisplayImageAction'

interface Props {
  clockPicture: ClockPicture
  employeeFullName: string
}

const Actions = ({ clockPicture, employeeFullName }: Props) => {
  const [isOpen, toggleOpen] = useToggle(false)
  const [isConfirmationOpen, toggleConfirmation] = useToggle(false)
  const [previewOpen, openPreviewModal] = React.useState(false)

  const onDeleteClockPicture = async () => {
    await asyncAction(() => clockPicture.destroy())
  }

  const options = [
    {
      href: clockPicture.downloadUrl,
      title: i18n.t('employee_form.face_recognition_info.download'),
    },
    {
      onClick: toggleConfirmation(true),
      title: i18n.t('employee_form.face_recognition_info.delete'),
    },
  ]

  const onClose = () => openPreviewModal(false)

  return (
    <>
      <Box flexGrow flexDirection="row" justifyContent="flexEnd" gap="s8">
        <Popover
          attachment="top right"
          open={isOpen}
          targetAttachment="bottom center"
          toggle={toggleOpen}
        >
          <Button onClick={toggleOpen(true)} type="secondary" iconName="ellipsis" />
          <PopoverContent onClose={toggleOpen(false)} options={options} />
        </Popover>
        <DisplayImageAction openPreviewModal={openPreviewModal} />
      </Box>
      {previewOpen && (
        <ClockPicturePreview
          clockPicture={clockPicture}
          employeeFullName={employeeFullName}
          onClose={onClose}
        />
      )}
      {isConfirmationOpen && (
        <Modal
          title={i18n.t('time_tracking.settings.face_recognition.confirmation_modal.title')}
          description={i18n.t(
            'time_tracking.settings.face_recognition.confirmation_modal.description'
          )}
          illustration="input-field"
          onClose={toggleConfirmation(false)}
          onSubmit={onDeleteClockPicture}
          footer={
            <Button type="negative" submit>
              {i18n.t('time_tracking.settings.face_recognition.confirmation_modal.submit')}
            </Button>
          }
        />
      )}
    </>
  )
}

export default observer(Actions)
